import { Link, useLocation } from "react-router-dom"
import { useMemo } from "react"

import { Button } from "ui-kit/components-branded/index"
import { BottomFixed } from "components/Footer"
import { CallStatus } from "modules/Call/queries"
import { useInputDevicesContext } from "modules/Call/InputDevices"
import { useInitCallProvider } from "modules/Call/components/InitCallProvider"
import { AfterFooter } from "components"

const ENABLE_BUTTON_CALL_STATUSES: CallStatus[] = ["UPCOMING", "CURRENT", "STARTED"]

export function GoToCallButton({
    callLink,
    callStatus,
}: {
    callLink: string
    callStatus: CallStatus
}) {
    const [state] = useInitCallProvider()
    const [{ cameraAccessed, microphoneAccessed }] = useInputDevicesContext()
    const { key } = useLocation()

    const disabled = useMemo(
        () =>
            !!state.error ||
            state.loading ||
            !cameraAccessed ||
            !microphoneAccessed ||
            !ENABLE_BUTTON_CALL_STATUSES.includes(callStatus),
        [state.error, state.loading, cameraAccessed, microphoneAccessed, callStatus]
    )

    return (
        <div className="go-to-callbutton">
            <Link to={callLink} className="go-to-callbutton__link">
                <Button
                    color="primary"
                    className="mgt-3 go-to-callbutton__is-desktop"
                    disabled={disabled}
                >
                    Присоединиться
                </Button>
            </Link>
            <AfterFooter afterFooterKey={key}>
                <div className="go-to-callbutton__placeholder">
                    <BottomFixed className="go-to-callbutton__wrapper">
                        <Link to={callLink} className="go-to-callbutton__link">
                            <Button color="primary" isFullwidth disabled={disabled}>
                                Присоединиться
                            </Button>
                        </Link>
                    </BottomFixed>
                </div>
            </AfterFooter>
        </div>
    )
}
